import {api} from "../../services";
import Swal from "sweetalert2";

const lead_requests = {
    state: {
        search:"",
        pagination: [],     
        data: [],
        category: {},
        new_lead_request: {
            title:null,
            description:null,
            ticket_id:null,
            category_id:null,
            subcategory_id:null,
            expireted_at:null,
        },
        model_lead_request: {
            description:null,
            ticket_id:null,
            category_id:null,
            subcategory_id:null,
            expireted_at:null,
        },
    },
    getters: {
        getLeadRequestObject: (state) => (key, value) => {
            const object = state.data.find(item => {
                return item[`${key}`] === value;
            });
            return object === undefined ? {} : object;
        },
        getLeadRequestsArray: (state) => (key, value) => {
            if (state.data !== undefined) {
                return state.data.filter(item => {
                    return item[`${key}`] === value;
                });
            }
            return [];
        },
    },
    mutations: {
        SET_LEAD_REQUESTS(state, payload) {
            state.pagination = payload
        },
        SET_LEAD_REQUESTS_DATA(state, payload) {
            payload.forEach(p => {
                const exist = state.data.find(e => {
                    return e.id === p.id;
                });
                if (!exist) {
                    state.data.push(p);
                }
            });
        },
        SET_LEAD_REQUEST(state, payload) {
            state.data = payload
        },
    },
    actions: {
        getLeadRequests(context, payload) {
            api.get('/lead/lead-request/', {
                params: payload
            }).then(response => {
                context.rootState.lead_requests.data = response.data.data;
                //context.commit("SET_LEAD_REQUESTS", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        getLeadRequestsData(context, payload) {
            let ids = [];
            payload.forEach(p => {
                const item = context.state.data.find(i => {
                    return p === i.id
                });
                if (item === undefined) {
                    ids.push(p);
                }
            });
            if (ids.length > 0) {
                api.post(`/lead-request/category`, {ids}).then(response => {
                    context.commit("SET_LEAD_REQUESTS_DATA", response.data);
                }).catch(error => {
                    if (error.response.status === 401) {
                        this.dispatch('logoutUser');
                    } else {
                        Swal.fire(
                          `${ context.rootGetters.getTranslations('expression_406')}`,
                          `${error.response.data.message}`,
                          'warning'
                        )
                    }
                });
            }
        },
        getLeadRequestsAll(context) {
            api.get(`/lead-request/all`).then(response => {
                context.commit("SET_LEAD_REQUESTS_DATA", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        addLeadRequest(context, payload) {
            api.post(`/lead/lead-request/`, payload).then(() => {
                //this.dispatch('getLeadRequests', {department_id: payload.department_id})

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Ticket cadastrado com sucesso!',
                    showConfirmButton: false,
                    timer: 1500
                });

                context.dispatch('getLeadRequests', {
                    lead_id: context.rootState.lead_requests.new_lead_request.lead_id
                });
                context.rootState.lead_requests.new_lead_request = context.rootState.lead_requests.model_lead_request;

            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        
        updateLeadRequest(context, payload) {
            api.put(`/lead-request/category/${payload.id}`, payload).then(response => {
                this.dispatch('getLeadRequests', {department_id: payload.department_id})
                // this.dispatch('getLeadRequests', payload.channel_id)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: context.rootGetters.getTranslations('expression_929'),
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        deleteLeadRequest(context, payload) {
            api.delete(`/lead-request/category/${payload.id}`).then(() => {
              this.dispatch('getLeadRequests', {department_id: payload.department_id})
                Swal.fire(
                  `${ context.rootGetters.getTranslations('expression_906')}`,
                  `${ context.rootGetters.getTranslations('expression_930')}`,
                  'success'
                )
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        deleteSubLeadRequest(context, payload) {
            api.delete(`/lead-request/subcategory/${payload.id}`).then(() => {
              this.dispatch('getLeadRequests', {department_id: payload.department_id})
                Swal.fire(
                  `${ context.rootGetters.getTranslations('expression_906')}`,
                  `${ context.rootGetters.getTranslations('expression_930')}`,
                  'success'
                )
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
    },
}
export default lead_requests;
